// 全局 Promise.withResolvers polyfill 初始化脚本
// 这个文件必须在所有其他模块之前加载，确保 polyfill 在任何第三方库使用前就已经可用

// 立即执行函数，确保 polyfill 在模块加载时就被注入
(function initializePromiseWithResolversPolyfill() {
  'use strict';
  
  console.log('[POLYFILL INIT] Initializing Promise.withResolvers polyfill...');
  
  // 获取全局对象
  const globalScope = (function() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    if (typeof self !== 'undefined') return self;
    throw new Error('Unable to locate global object');
  })();
  
  // 检查 Promise 构造函数是否存在
  if (!globalScope.Promise) {
    console.error('[POLYFILL INIT] Promise constructor not found in global scope');
    return;
  }
  
  // 强制注入 polyfill（即使原生方法存在也要覆盖，确保兼容性）
  const withResolversPolyfill = function<T = any>() {
    let resolve: (value: T | PromiseLike<T>) => void;
    let reject: (reason?: any) => void;
    
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    
    return {
      promise,
      resolve: resolve!,
      reject: reject!
    };
  };
  
  // 使用多种方法强制注入，确保在各种环境下都能成功
  let injectionSuccess = false;
  const methods: string[] = [];
  
  // 方法 1: 直接赋值
  try {
    globalScope.Promise.withResolvers = withResolversPolyfill;
    if (typeof globalScope.Promise.withResolvers === 'function') {
      injectionSuccess = true;
      methods.push('direct');
    }
  } catch (e) {
    console.warn('[POLYFILL INIT] Direct assignment failed:', e);
  }
  
  // 方法 2: Object.defineProperty
  try {
    Object.defineProperty(globalScope.Promise, 'withResolvers', {
      value: withResolversPolyfill,
      writable: true,
      configurable: true,
      enumerable: false
    });
    if (typeof globalScope.Promise.withResolvers === 'function') {
      injectionSuccess = true;
      methods.push('defineProperty');
    }
  } catch (e) {
    console.warn('[POLYFILL INIT] Object.defineProperty failed:', e);
  }
  
  // 方法 3: Reflect.defineProperty
  if (typeof Reflect !== 'undefined' && typeof Reflect.defineProperty === 'function') {
    try {
      Reflect.defineProperty(globalScope.Promise, 'withResolvers', {
        value: withResolversPolyfill,
        writable: true,
        configurable: true,
        enumerable: false
      });
      if (typeof globalScope.Promise.withResolvers === 'function') {
        injectionSuccess = true;
        methods.push('reflect');
      }
    } catch (e) {
      console.warn('[POLYFILL INIT] Reflect.defineProperty failed:', e);
    }
  }
  
  // 方法 4: 原型操作（最后的手段）
  if (!injectionSuccess) {
    try {
      // 删除可能存在的描述符
      if (Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(globalScope.Promise, 'withResolvers')) {
        delete globalScope.Promise.withResolvers;
      }
      
      // 强制赋值
      globalScope.Promise.withResolvers = withResolversPolyfill;
      
      if (typeof globalScope.Promise.withResolvers === 'function') {
        injectionSuccess = true;
        methods.push('prototype');
      }
    } catch (e) {
      console.error('[POLYFILL INIT] Prototype manipulation failed:', e);
    }
  }
  
  // 验证注入结果
  if (injectionSuccess) {
    console.log(`[POLYFILL INIT] Promise.withResolvers polyfill successfully injected via: ${methods.join(', ')}`);
    
    // 功能测试
    try {
      const test = globalScope.Promise.withResolvers<string>();
      if (test && test.promise && test.resolve && test.reject) {
        test.resolve('polyfill-test-success');
        test.promise.then((value) => {
          console.log('[POLYFILL INIT] Functional test passed:', value);
        }).catch((error) => {
          console.error('[POLYFILL INIT] Functional test failed:', error);
        });
      } else {
        console.error('[POLYFILL INIT] Functional test failed: invalid return structure');
      }
    } catch (error) {
      console.error('[POLYFILL INIT] Functional test error:', error);
    }
    
    // 设置全局标记
    globalScope.__PROMISE_WITH_RESOLVERS_POLYFILL_INIT__ = true;
    globalScope.__PROMISE_WITH_RESOLVERS_POLYFILL_METHODS__ = methods;
  } else {
    console.error('[POLYFILL INIT] CRITICAL: Failed to inject Promise.withResolvers polyfill after all attempts');
    globalScope.__PROMISE_WITH_RESOLVERS_POLYFILL_FAILED__ = true;
  }
})();

// TypeScript 类型声明
declare global {
  interface PromiseConstructor {
    withResolvers<T = any>(): {
      promise: Promise<T>;
      resolve: (value: T | PromiseLike<T>) => void;
      reject: (reason?: any) => void;
    };
  }
  
  interface Window {
    __PROMISE_WITH_RESOLVERS_POLYFILL_INIT__?: boolean;
    __PROMISE_WITH_RESOLVERS_POLYFILL_METHODS__?: string[];
    __PROMISE_WITH_RESOLVERS_POLYFILL_FAILED__?: boolean;
  }
}

export {};